const imagePath = `/images/section/about/`;

export const aboutMarqueeConfig = [
  { path: `${imagePath}1.jpg` },
  { path: `${imagePath}2.jpg` },
  { path: `${imagePath}3.jpg` },
  { path: `${imagePath}4.jpg` },
  { path: `${imagePath}5.jpg` },
  { path: `${imagePath}6.jpg` },
  { path: `${imagePath}7.jpg` },
  { path: `${imagePath}8.jpg` },
  { path: `${imagePath}9.jpg` },
  { path: `${imagePath}10.jpg` },
  { path: `${imagePath}11.jpg` },
  { path: `${imagePath}12.jpg` },
];
